"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryWxWorkCfgPage = queryWxWorkCfgPage;
exports.saveCfg = saveCfg;
exports.updateCfg = updateCfg;
exports.wxWorkCfgCombobox = wxWorkCfgCombobox;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 获取配置常量
function wxWorkCfgCombobox() {
  return (0, _requestPIM.default)({
    url: "/wxWorkCfg/combobox",
    method: "get"
  });
}
function queryWxWorkCfgPage(query) {
  return (0, _requestPIM.default)({
    url: "/wxWorkCfg/page",
    method: "get",
    params: query
  });
}
// 新增渠道
function saveCfg(data) {
  return (0, _requestPIM.default)({
    url: '/wxWorkCfg',
    method: 'post',
    data: data
  });
}
// 编辑渠道
function updateCfg(data) {
  return (0, _requestPIM.default)({
    url: '/wxWorkCfg',
    method: 'put',
    data: data
  });
}